import { MegaraxClient } from "@megarax/client/src";
import {
  BaseResource,
  HttpResourceProvider,
  ResourceProvider,
  ResourceNodes,
} from "@megarax/rest-resource";
import { useMegaraxClient } from "./useMegaraxClient";

export type HttpClient = {
  get: (url: string, query?: any) => Promise<any>;
  post: (url: string, query?: any, body?: any) => Promise<any>;
  put: (url: string, query?: any, body?: any) => Promise<any>;
  delete: (url: string, query?: any, body?: any) => Promise<any>;
};

export const megaraxClientResourceProvider = (megaraxClient: MegaraxClient) => {
  const httpClient: HttpClient = {
    get: (url, params) =>
      megaraxClient.get(url, { params }).then((r) => r.data),
    post: (url, params, data) =>
      megaraxClient.post(url, data, { params }).then((r) => r.data),
    put: (url, params, data) =>
      megaraxClient.put(url, data, { params }).then((r) => r.data),
    delete: (url, params, data) =>
      megaraxClient.delete(url, { params, data }).then((r) => r.data),
  };

  return HttpResourceProvider(httpClient);
};

export const useResourceProvider = <TResource extends ResourceNodes>(
  resource: BaseResource<TResource>,
): ResourceProvider<TResource> => {
  const megaraxClient = useMegaraxClient();
  return megaraxClientResourceProvider(megaraxClient)(resource);
};
